module.exports = __webpack_public_path__ + "img/achievement_14.955ad856.png";